<template>
  <fragment>
    <div class="table-wrapper">
      <div class="btn-all">
        <el-button size="98" v-if="type === 'authorizedGoods'" class="export-color"
          @click="handleGoodsStatus(params['goodsUpOperator'])" v-permission:goodsUp="$route.meta.permission">
          上架
        </el-button>
        <el-button v-if="['inSalesGoods', 'soldOutGoods'].includes(type)" size="98" class="export-color"
          @click="handleGoodsStatus(params['goodsDownOperator'])" v-permission:goodsDown="$route.meta.permission">
          下架
        </el-button>
        <el-button size="98" class="del-color" v-if="!noDel" @click="handleGoodsStatus(params['del'])"
          v-permission:del="$route.meta.permission">
          删除
        </el-button>
        <el-button size="98" class="obtained-color" @click="openExportPop" v-permission:export="$route.meta.permission">
          导出
        </el-button>
      </div>
      <el-table v-min-height ref="table" :data="tableData" :height="500" @selection-change="handleSelectionChange"
        class="no-hover">
        <el-table-column fixed type="selection" align="center" width="130" />
        <el-table-column prop="id" label="序号" align="center" min-width="60" />
        <el-table-column class-name="visible" align="center" label="商品标题" min-width="400">
          <template slot-scope="scope">
            <el-image :src="scope.row.img" :preview-src-list="[scope.row.img]" class="goods-img">
              <div slot="error" class="image-slot">
                <i class="iconfont icon-tupian"></i>
              </div>
            </el-image>
            <div class="caption">
              <p class="ellipses">
                <el-tooltip effect="light" placement="bottom-start" :content="scope.row.cnName">
                  <span class="goods-name">
                    <el-input placeholder="中文名" suffix-icon="el-icon-edit" class="editor"
                      @change="modify('name', scope.row)" v-model="scope.row.cnName" />
                  </span>
                </el-tooltip>
              </p>
              <p class="ellipses">
                <el-tooltip effect="light" placement="bottom-start" :content="scope.row.enName">
                  <span class="goods-name">
                    <el-input placeholder="英文名" suffix-icon="el-icon-edit" class="editor"
                      @change="modify('name', scope.row)" v-model="scope.row.enName" />
                  </span>
                </el-tooltip>
              </p>
              <p class="ellipses">
                <el-tooltip effect="light" placement="bottom-start" :content="scope.row.sku">
                  <span class="goods-name">{{ scope.row.sku }}
                    <!-- <el-input placeholder="SKU编码" suffix-icon="el-icon-edit" class="editor"
                      @change="modify('sku', scope.row)" v-model="scope.row.sku" /> -->
                  </span>
                </el-tooltip>
              </p>
              <p class="ellipses relative">
                <el-tooltip effect="light" placement="bottom-start" :content="scope.row.appletsUrl">
                  <span class="goods-name">
                    小程序地址：{{ scope.row.appletsUrl }}
                  </span>
                </el-tooltip>
                <i class="iconfont icon-lianjie" v-clipboard:copy="scope.row.appletsUrl" v-clipboard:success="onCopy" />
              </p>
              <p class="ellipses applets">
                <span class="goods-name">
                  小程序二维码：<img class="ewm" :src="scope.row.qrImg" alt="" />
                </span>
                <i class="iconfont icon-fuzhi" v-clipboard:copy="scope.row.qrImg" v-clipboard:success="onCopy" />
              </p>
              <p class="ellipses relative">
                <span class="goods-name"> 复制商品图片： </span>
                <i class="iconfont icon-fuzhi" v-clipboard:copy="scope.row.img" v-clipboard:success="onCopy" />
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="['authorizedGoods', 'inSalesGoods'].includes(type)" sortable sort-by align="center"
          label="销售价格" min-width="720">
          <template slot-scope="scope">
            <div class="editor-price__info">
              <p class="info" v-for="item in scope.row.salesSize" :key="item.salesId">
                <span class="tips">
                  <span class="num">{{ item.salesNumber }}</span>支装授权销售价格范围
                </span>
                <span class="range">
                  <span class="red range-price">{{
                    item.startPrice | formatMoney
                  }}</span>
                  至
                  <span class="red range-price">{{
                    item.endPrice | formatMoney
                  }}</span>
                </span>
                <span class="txt">授权价格:</span>
                <el-input suffix-icon="el-icon-edit" class="editor" @change="modify('price', scope.row, item)"
                  v-model="item.goodsPrice" />
                元
                <span class="txt">销售价格:</span>
                <span class="sales-price red">
                  {{ item.salesPrice }}
                </span>
                元
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="salesVolume" label="近30天的销量" sortable align="center" min-width="180" />
        <el-table-column prop="stock" label="库存" align="center" sortable sort-by min-width="180" />
        <el-table-column prop="time" :label="$route.name === 'inSalesGoods' ? '上架时间' : '同步时间'" align="center" sortable
          min-width="180" />
        <el-table-column v-if="!params.authorized" label="商品状态" align="center" min-width="180">
          <template slot-scope="scope">
            {{ scope.row.state | formatState }}
          </template>
        </el-table-column>
        <el-table-column v-if="$route.name.includes('Sales')" fixed="right" label="操作" align="center" min-width="220"
          class-name="visible">
          <template slot-scope="scope">
            <el-button size="36" v-permission:editor="$route.meta.permission" class="iconfont icon-bianji" round
              @click="jumpRoute(scope.row)" />
            <el-button v-if="['authorizedGoods', 'inSalesGoods'].includes(type)" size="36"
              v-permission:goodsDown="$route.meta.permission" class="iconfont icon-xiajia export-color" @click="
                handleGoodsStatus(
                  params['goodsDownOperator'],
                  scope.$index,
                  scope.row
                )
                " round />
            <el-button v-permission:goodsUp="$route.meta.permission" size="36" v-if="type === 'authorizedGoods'"
              class="iconfont icon-shangjia export-color" @click="
                handleGoodsStatus(
                  params['goodsUpOperator'],
                  scope.$index,
                  scope.row
                )
                " round />
            <div class="template-setting">
              <el-button size="120" v-permission:editor="$route.meta.permission" class="fff-color"
                @click="transportTemplateSettings(scope.row)" round>
                运费模板设置
              </el-button>
              <el-button size="120" v-permission:editor="$route.meta.permission" class="fff-color"
                @click="salesAreaSettings(scope.row)" round>
                销售区域设置
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <Pagination ref="pagination" v-if="pagination.recordTotal >= 1" :currentPage="pagination.currentPage"
        :totalPage="pagination.pageTotal" :totalRecord="pagination.recordTotal" @handleNextPage="nextPage"
        @handlePrevPage="prevPage" @handleJumpPage="jumpPage" @handleChangePageSize="changePageSize" />
    </div>
    <Export ref="excel" :funcName="excelProps.func" :id="multipleSelection" :state="excelProps.state"
      :excelName="excelProps.name" />
  </fragment>
</template>
<script>
import tableOpearting from 'mixins/tableOpearting/'

export default {
  name: 'tableComponent',
  mixins: [tableOpearting],
  filters: {
    formatState(val) {
      const state = ['正常', '下架', '放入回收站']
      return state[+val - 1]
    },
  },
  props: {
    tableData: {
      type: Array,
    },
    pagination: {
      type: Object,
    },
    type: {
      type: String,
    },
    params: {
      type: Object,
    },
    noDel: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    excelProps() {
      let type = ''
      switch (this.type) {
        case 'inWareHouse':
          type = 'warehouse'
          break
        case 'noAuthorizedGoods':
          type = 'unauthorized'
          break
        default:
          type = 'authorized'
          break
      }
      return {
        func: 'exportGoods',
        name: '商品列表',
        state: type,
      }
    },
  },
  methods: {
    /**
     * 调用父组件请求数据函数
     * @param vm
     * @param newValue
     * @param type
     * @param size
     * @private
     */
    _parentComponentRequest(vm, newValue, type, size) {
      const condition = vm.$refs.search[0]._returnSearchCondition()
      const data = vm._switchParamsType(vm.activeName, newValue)
      vm._getGoodsList({ ...data, ...condition, pageSize: size }, type)
    },
    /**
     * 销售区域设置显示
     * @param row
     */
    salesAreaSettings(row) {
      this.$emit('openPop', row, 'salesArea')
    },
    /**
     * 运费模板设置显示
     * @param row
     */
    transportTemplateSettings(row) {
      this.$emit('openPop', row, 'transportTemplate')
    },
    /**
     * 上架下架删除商品
     * @param type
     * @param rows
     * @param index
     */
    handleGoodsStatus(type, index, rows) {
      const routeName = this.$route.name
      let tips
      switch (routeName) {
        case 'inSalesGoods':
          this.handleType = type
          tips = type === 'forsales' ? '下架' : '删除'
          break
        case 'forSalesGoods':
          this.handleType = type
          if (this.type === 'authorizedGoods') {
            tips = type === 'onsales' ? '上架' : '下架'
          } else if (this.type === 'noAuthorizedGoods') {
            tips = type === 'recycle' ? '下架' : '删除'
          } else {
            tips = type === 'putaway' ? '上架' : '删除'
          }
      }

      // 上架前检测商品授权价格
      if (type === 'onsales') {
        const result = this._checkGoodsPrice(
          (rows && rows.salesSize) || this.multipleSelection
        )
        if (result) return
      }
      if (rows) {
        this.handleDelete(
          index,
          { id_array: rows.id },
          `${tips}1条商品吗？`,
          '确定'
        )
        return
      }
      this.handleSelectionDel(tips, this.type, '确定')
    },
    /**
     * 批量删除（下架 上架）
     * @returns {*|Promise}
     * @private
     */
    _multipleDel() {
      const idAll = this.multipleSelection
        .map((v) => {
          return v.id
        })
        .join(',')
      return this.delRows({
        id_array: idAll,
      })
    },
    /**
     * 请求删除行
     * @param obj
     * @returns {Promise}
     */
    delRows(obj) {
      return this.api
        .changeGoodsStatus({
          handle_type: this.handleType,
          ...obj,
        })
        .then((res) => {
          this.$notify({
            type: 'success',
            message: res.message,
          })
        })
    },
    /**
     * 修改商品价格、名称、sku
     * @param type
     * @param row
     * @param item
     */
    modify(type, row, item) {
      const search_model =
        this.$route.name === 'forSalesGoods' ? 'authorized' : 'on_sale'
      let data = {
        change_type: type,
        search_model,
        goods_id: row.id,
      }
      switch (type) {
        case 'price':
          const {
            goodsPrice,
            startPrice,
            endPrice,
            salesId,
            salesNumber,
            authorizedId,
          } = item
          if (goodsPrice == 0) {
            this.$notify({
              type: 'warning',
              message: '商品授权价格不能为0~！',
            })
            return
          }
          data = {
            ...data,
            authorized_id: authorizedId,
            goods_price: goodsPrice,
            authorized_start_price: startPrice,
            authorized_end_price: endPrice,
            sales_id: salesId,
            sales_quantity: salesNumber,
            goods_type: row.goodsType,
          }
          break
        case 'sku':
          data = {
            ...data,
            goods_sku: row.sku,
            spec_id: row.specId,
            is_combination: row.isCombination,
          }
          break
        case 'name':
          data = {
            ...data,
            goods_name: row.cnName,
            goods_en: row.enName,
          }
          break
      }
      this.api.modifyGoods(data).then((res) => {
        this.$notify({
          type: 'success',
          message: '修改成功！🙂',
        })
      })
    },
    /**
     * 跳转到商品详情页
     * @param rows
     */
    jumpRoute(rows) {
      const { id, cnName, goodsMerchantId } = rows
      this.$router.push({
        name: 'newProductRelease',
        query: {
          id: id,
          title: cnName,
          merchantId: goodsMerchantId,
        },
      })
    },
    /**
     * 商品上架之前检测是否授权了商品价格
     * @param list
     * @returns {Boolean}
     * @private
     */
    _checkGoodsPrice(list) {
      const handleResult = (arr) => {
        return arr.some((v) => {
          const { goodsPrice, startPrice, endPrice } = v
          let result
          if (Number(goodsPrice) < Number(startPrice) || Number(goodsPrice) > Number(endPrice)) {
            result = true
          } else {
            result = false
          }

          if (result) {
            this.$notify({
              type: 'warning',
              message: '商品上架还有价格未授权~！',
            })
            return result
          }
        })
      }
      const { goodsPrice } = list[0]
      if (goodsPrice) {
        return handleResult(list)
      } else {
        return list.some((v) => {
          const { salesSize } = v
          return handleResult(salesSize)
        })
      }
    },
    /**
     * 复制图片到剪贴板
     */
    onCopy(res) {
      if (process.env.IS_ELECTRON && res.text.includes('http')) {
        this.utils._getUrlBase64(res.text).then((base64) => {
          const img = require('electron').nativeImage.createFromDataURL(base64)
          require('electron').clipboard.writeImage(img)
        })
      }
      this.$notify({
        type: 'success',
        message: '复制成功啦~！😁',
      })
    },
  },
}
</script>

<style lang="scss">
.sales_goods {
  .template-setting {
    margin-top: 0.5rem;
    @extend .winner-flex;
    flex-direction: column;

    .fff-color {
      padding: 0 !important;
      height: 2rem;
      border-radius: 1rem;
      margin-left: 0;

      &:first-child {
        margin-bottom: 0.6rem;
      }
    }
  }

  .editor-price__info {
    text-align: left;

    .info {
      padding-bottom: 0.5rem;
    }

    .editor {
      width: 7rem;
      margin: 0 0.5rem;
      white-space: nowrap;

      input {
        height: 2rem;
        color: colors('bg-sub');
      }
    }

    .num {
      text-align: right;
      display: inline-block;
      min-width: 1.3rem;
      white-space: nowrap;
    }

    .range-price {
      display: inline-block;
      min-width: 3rem;
      white-space: nowrap;
    }

    .txt {
      padding: 0 0.5rem;
    }

    .el-input__icon {
      line-height: 2rem;
    }
  }

  .icon-lianjie {
    position: absolute;
    right: 0;
  }

  .icon-fuzhi {
    &:after {
      bottom: initial;
    }
  }

  .ellipses {
    &.relative {
      padding-right: 1rem;
    }

    input {
      height: initial;
      line-height: initial;
      background: transparent;
      padding-left: 0;
      padding-right: 20px;
      @extend .ellipses;
    }

    .el-input__icon {
      line-height: initial;
      padding-left: 1rem;
    }



  }
}
</style>
